import React, { useCallback, useEffect } from 'react';
import { useFocusEffect, useNavigation } from '@react-navigation/native';

import { Bag } from '@order/features/ordering';
import { useCloseBag } from '@order/hooks';
import { useFeatureFlag } from '@order/LaunchDarkly';

import { BagAnimatedDialog, BagContent } from './components';
import { useOrderState } from './hooks';

export const BagScreen = () => {
  const isLoyaltyV2Enabled = useFeatureFlag('CELS-2685-loyalty-v2-enabled');
  const isExpressPaymentsEnabled = useFeatureFlag(
    'permanent-order-stripe-express-checkout-enabled',
  );

  const orderState = useOrderState({
    isLoyaltyV2Enabled,
    isExpressPaymentsEnabled,
  });

  const { isShowingModal } = orderState;
  const closeBag = useCloseBag();

  // ─── Navigation Options ───────────────────────────────────────────────────
  // We are disabling gestures when the animated dialog is shown, as we don't want users to dismiss the bag when attempting to dismiss it.
  // When the screen is unfocused, we re-enable the gestures so it doesn't break other screens in the modal stack.

  const navigation = useNavigation();

  useEffect(() => {
    navigation.getParent()?.setOptions({ gestureEnabled: !isShowingModal });
  }, [navigation, isShowingModal]);

  useFocusEffect(
    useCallback(() => {
      return () => {
        navigation.getParent()?.setOptions({ gestureEnabled: true });
      };
    }, [navigation]),
  );

  // ──────────────────────────────────────────────────────────────────────────

  return (
    <Bag.DynamicModal onClose={closeBag}>
      <BagContent orderState={orderState} />

      <BagAnimatedDialog orderState={orderState} />
    </Bag.DynamicModal>
  );
};
